module.exports = __webpack_public_path__ + "img/bank-azteca.cd557d74.jpeg";